import styled from "styled-components";
import { Spinner } from "@pepdirect/v3/ui/Spinner";

export const StyledNewApplePayText = styled.div`
  font-size: 13px;
  margin: 16px 0 40px;
`;

export const StyledSpinner = styled(Spinner)`
  width: 214px;
  height: 48px;
`;
